import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import FlexiblePageWrapper from '../components/wrapper/FlexiblePageWrapper';
import Header from './../components/general/Header';
import Title from './../components/text/Title';
import Subtitle from '../components/text/Subtitle';
import Button from './../components/general/Button';
import VideoInfo from '../components/video/VideoInfo';
import Footer from './../components/general/Footer';

function SurveyEnd() {
  const { t } = useLanguage();

  return (
    <FlexiblePageWrapper>
      <Header text={t('headerTitle')} />
      <main className="w-full max-w-4xl mx-auto sm:px-4 pt-40 pb-28 flex flex-col items-center gap-6">
        <Title size="small" text={t('title')} />
        <Subtitle text={t('surveyComplete')} />
        <div className="px-8">
          <Subtitle text={t('surveyCompleteText')} size="small" />
        </div>
        <br />
        <Link to="/">
          <Button text={t('goHome')} />
        </Link>
        <br />
        <br />
        <br />
        <VideoInfo />
      </main>
      <Footer />
    </FlexiblePageWrapper>
  );
}
export default SurveyEnd;
